<template>
  <div class="categoryContainer">
    <!-- Category Item -->
    <!-- <b-row>
    <b-col @click="reloadProductList(item.path)" class="text-center pointer" cols="3" v-for="item in category">
      <img :src="item.url" width="40" height="40">
      <span class="d-block categoryLabel">{{item.label}}</span>
    </b-col>
  </b-row> -->
    <scroller lock-y :scrollbar-x=false>
      <div class="categoryRow">
        <div @click="onClick(item.ID)" class="categoryItem" v-for="item in categoryList"><span>{{getTranslation(item,'name') }}</span></div>
      </div>
    </scroller>
  </div>
</template>
<script type="text/javascript">
import { FITFormCard, FITCheckbox, FITSelect, FITTextInput, FITInputTag, FITButton } from '@/components'
import { mapGetters } from 'vuex'
import { Scroller } from 'vux'
export default {
  name: 'CategoryList',
  components: {
    FITCheckbox,
    FITSelect,
    FITTextInput,
    FITInputTag,
    FITButton,
    FITFormCard,
    Scroller,
  },
  props: {},
  data() {
    return {}
  },
  created() {
  },
  mounted() {

  },
  watch: {},
  computed: {
    ...mapGetters([
      'getTranslatedData'
      ]),

    currentRoute(){
      return this.$router.currentRoute;
    },
    categoryList() {
      return this.$store.state.Shop.categoryList;

    }
  },
  methods: {
    getTranslation(data,key){
      let locale = this.$i18n.locale;
      return this.getTranslatedData(locale,data,key);
    },
    reloadProductList(path) {
      this.$router.push(path);
    },
    onClick(ID){
      // console.log(ID);
        this.$store.commit('setSearchCategory',{categoryID:ID});
        this.$store.commit('resetCurrentPages')
    }
  },
}

</script>
<style type="text/css">
.categoryLabel {
  font-size: 0.7rem;
  margin: 0px;
  font-weight: 500;
  color: #888888;

}

.categoryContainer {
  background: white;
  /*    padding:2px 15px 5px 15px; 
*/
}

.categoryRow {
  height: 30px;
  position: relative;
  width: 980px;
}

.categoryItem {
  width: 70px;
  height: 30px;
  margin: 10px 0 10px;
  background-color: #fff;
  display: inline-block;
  /*  margin-left: 15px;
*/
  float: left;
  font-size: 13px;
  text-align: center;
  line-height: 30px;
  color:#555555;

}

</style>



// WEBPACK FOOTER //
// src/components/Header/CategoryList.vue